// extracted by mini-css-extract-plugin
export default {"sidebarToggleButton":"Sidebar-module__sidebarToggleButton--BTgQX","sidebarHeading":"Sidebar-module__sidebarHeading--_5A3l"};